import { Component } from 'preact';
import style from './style';

import find from 'dlv';

import { Stateful } from '@components/pubsub';
import Modal from '@components/modal';
import Input from '@components/input';
import Button from '@components/button';
import Checkbox from '@components/checkbox';
import { CountryCodeSelector } from '@routes/book/CountryCodeSelector';

import Text from '@components/translate';
import I18n from 'i18nline';
import { fixEmail } from '@helpers';

export const EmailForm = ({
  error,
  auth,
  noTitles,
  loading,
  onChange,
  onSubmit,
  onCreate,
  onForgot,
}) => (
  <div class={style.detailForm}>
    {noTitles ? null : (
      <Text p class={style.formIntro}>{I18n.t(
        "You're just few steps away from using the most convenient restaurant booking service there is. Just enter your email to get started."
      )}</Text>
    )}
    {error ? <div class={style.error}>{error}</div> : null}
    <form onSubmit={onSubmit} class={style.singleForm}>
      <Input
        size="full"
        placeholder={I18n.t('Email address')}
        type="email"
        name="email"
        id="email"
        pattern={
          "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$"
        }
        value={auth.email}
        onInput={e => onChange({ email: e.target.value })}
        onChange={e => onChange({ email: e.target.value })}
        onBlur={e => onChange({ email: fixEmail(e.target.value).trim() })}
      />
      <input
        style={'height:1px;width:1px;overflow:hidden;opacity:0;border:0;'}
        placeholder={I18n.t('Password')}
        minlength="8"
        maxlength="50"
        type="password"
        name="password"
        id="password"
        autocomplete="current-password"
        value={auth.password}
        onInput={e => onChange({ password: e.target.value })}
        onChange={e => onChange({ password: e.target.value })}
      />
      <Button class={`${style.darkButton} defaultButton`} loading={loading}>{I18n.t("Next")}</Button>
    </form>
    <div class={style.secondaryActions}>
      <p>
        <Button class={style.forgotPassword} onClick={onForgot}>
          {I18n.t('Forgot your password?')}
        </Button>
      </p>
      <p>
        <Button class="defaultLink" onClick={onCreate}>
          {I18n.t('Create account')}
        </Button>
      </p>
    </div>
  </div>
);

export class ForgotPassword extends Component {
  render({ error, auth, loading, noTitles, onChange, onSubmit, onBack }) {
    return (
      <div class={style.detailForm}>
        {noTitles ? null : (
          <Text p class={style.formIntro}>{I18n.t(
            "If you have an account with us, enter your email below and check your inbox."
          )}</Text>
        )}
        {error ? <div class={style.error}>{error}</div> : null}
        <form onSubmit={onSubmit}>
          <div class={style.emailField}>
            <Input
              size="full"
              placeholder={I18n.t('Email address')}
              type="email"
              autocomplete="email"
              pattern={
                "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$"
              }
              value={auth.email}
              onInput={e => onChange({ ...auth, email: e.target.value })}
              onBlur={e =>
                onChange({ ...auth, email: fixEmail(e.target.value).trim() })
              }
            />
          </div>
          <div class={style.rightSideButton}>
            <Button class={`${style.darkButton} defaultButton`} loading={loading}>{I18n.t("Next")}</Button>
          </div>
        </form>
        <div class={style.secondaryActions}>
          <p>
            <Button class="defaultLink" onClick={onBack}>
              {I18n.t('Go back')}
            </Button>
          </p>
        </div>
      </div>
    );
  }
}

export const ResetPassword = ({
  error,
  auth,
  loading,
  noTitles,
  onChange,
  onSubmit,
  onBack,
  onForgot,
}) => (
  <div class={style.detailForm}>
    {noTitles ? null : (
      <Text p class={style.formIntro}>{I18n.t(
        "Enter a new password and confirmation code below and you're on your way to logging in!"
      )}</Text>
    )}
    <form onSubmit={onSubmit}>
      {error ? (
        <div class={style.error}>
          <p class="hug">{error}</p>
          <div class={style.secondaryActions}>
            <p>
              <Button
                class="defaultButton"
                style="opacity:1"
                type="button"
                onClick={e => {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  onForgot();
                }}
              >
                {I18n.t('Order a new verification code')}
              </Button>
            </p>
          </div>
        </div>
      ) : null}
      <div class={style.emailField}>
        <Input
          size="full"
          placeholder={I18n.t('Email address')}
          type="email"
          autocomplete="email"
          pattern={
            "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$"
          }
          value={auth.email}
          onInput={e => onChange({ ...auth, email: e.target.value })}
          onBlur={e =>
            onChange({ ...auth, email: fixEmail(e.target.value).trim() })
          }
        />
      </div>
      <div class={style.emailField}>
        <Input
          size="full"
          placeholder={I18n.t('Confirmation code')}
          type="text"
          value={auth.resetkey}
          onInput={e => onChange({ ...auth, resetkey: e.target.value })}
        />
      </div>
      <div class={style.sideBySide}>
        <div class={style.leftInput}>
          <Input
            size="full"
            placeholder={I18n.t('Password')}
            minlength="8"
            maxlength="50"
            type="password"
            autocomplete="new-password"
            value={auth.password}
            onInput={e => onChange({ ...auth, password: e.target.value })}
          />
        </div>
        <div class={style.rightInput}>
          <Input
            size="full"
            placeholder={I18n.t('Password again')}
            minlength="8"
            maxlength="50"
            type="password"
            autocomplete="new-password"
            value={auth.repassword}
            onInput={e => onChange({ ...auth, repassword: e.target.value })}
          />
        </div>
      </div>
      <div class={style.rightSideButton}>
        <Button
          class={`${style.darkButton} defaultButton`}
          disabled={
            !(
              auth.email &&
              auth.resetkey &&
              auth.repassword &&
              auth.repassword === auth.password
            )
          }
          loading={loading}>{I18n.t("Save")}</Button>
      </div>
    </form>
    <div class={style.secondaryActions}>
      <p>
        <Button class={style.forgotPassword} onClick={onBack}>{I18n.t("Go back")}</Button>
      </p>
    </div>
  </div>
);

export const PersonalDetails = (
  {
    error,
    auth,
    loading,
    noTitles,
    onChange,
    onSubmit,
    acceptedTerms,
    onAccept,
    onEmail,
  },
  { lang }
) => (
  <div class={style.detailForm}>
    {noTitles ? null : (
      <Text p class={style.formIntro}>{I18n.t(
        "Cool to have you with us! We need a few additional details before we can officially get started."
      )}</Text>
    )}
    <form onSubmit={onSubmit}>
      {error ? <div class={style.error}>{error}</div> : null}
      <div class={style.emailField}>
        <Input
          size="full"
          placeholder={I18n.t('Email address')}
          type="email"
          autocomplete="email"
          pattern={
            "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$"
          }
          value={auth.email}
          onInput={e => onChange({ ...auth, email: e.target.value })}
          onBlur={e =>
            onChange({ ...auth, email: fixEmail(e.target.value.trim()) })
          }
        />
      </div>
      <div class={style.sideBySide}>
        <div class={style.leftInput}>
          <Input
            size="full"
            placeholder={I18n.t('First name')}
            autocomplete="given-name"
            value={auth.firstname}
            onInput={e => onChange({ ...auth, firstname: e.target.value })}
          />
        </div>
        <div class={style.rightInput}>
          <Input
            size="full"
            placeholder={I18n.t('Last name')}
            autocomplete="family-name"
            value={auth.lastname}
            onInput={e => onChange({ ...auth, lastname: e.target.value })}
          />
        </div>
      </div>
      <div class={style.sideBySide}>
        <div class={style.leftShortInput}>
          <CountryCodeSelector
            contact_info={auth}
            onChange={country_code => onChange({ ...auth, ...country_code })}
          />
        </div>
        <div class={style.rightLongInput}>
          <Input
            required
            size="small"
            type="tel"
            autocomplete="tel-national"
            error={find(error, 'auth.mobile_phone')}
            title={find(error, 'auth.mobile_phone')}
            placeholder={I18n.t('Mobile phone')}
            value={auth.mobile_phone}
            onInput={e =>
              onChange({ ...auth, mobile_phone: e.target.value.trim() })
            }
          />
        </div>
      </div>
      <div class={style.acceptTerms}>
        <Checkbox checked={acceptedTerms} onChange={onAccept}>
          <a href={`/${lang}/terms`} target="_blank">
            <Text p class={`${style.termsText} hug`}>{I18n.t("I agree to the TableOnline terms and conditions")}</Text>
          </a>
        </Checkbox>
      </div>
      <div class={style.rightSideButton}>
        <Button
          class={`${style.darkButton} defaultButton`}
          disabled={!acceptedTerms}
          loading={loading}
        >
          {I18n.t('Create an account')}
        </Button>
      </div>
    </form>
    <div class={style.secondaryActions}>
      <p>
        <Button class={style.forgotPassword} onClick={onEmail}>{I18n.t("Go back")}</Button>
      </p>
    </div>
  </div>
);

export const EnterPassword = ({
  error,
  auth,
  loading,
  noTitles,
  onChange,
  onSubmit,
  onEmail,
  onForgot,
}) => (
  <div class={style.detailForm}>
    {noTitles ? null : (
      <Text p class={style.formIntro}>{I18n.t("One more step to get you on your way, promise!")}</Text>
    )}
    {error ? <div class={style.error}>{error}</div> : null}
    <form onSubmit={onSubmit} class={style.singleForm}>
      <input
        class={style.hidden}
        autocomplete="email"
        type="email"
        name="email"
        pattern={
          "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$"
        }
        value={auth.email}
        hidden
      />
      <Input
        size="full"
        placeholder={I18n.t('Password')}
        minlength="8"
        maxlength="50"
        type="password"
        name="password"
        value={auth.password}
        autocomplete="current-password"
        onInput={e => onChange({ ...auth, password: e.target.value })}
      />
      <Button class={`${style.darkButton} defaultButton`} loading={loading}>{I18n.t("Login")}</Button>
    </form>
    <div class={style.secondaryActions}>
      <p>
        <Button class={style.forgotPassword} onClick={onForgot}>
          {I18n.t('Forgot your password?')}
        </Button>
      </p>
      <p>
        <Button class={style.forgotPassword} onClick={onEmail}>{I18n.t("Go back")}</Button>
      </p>
    </div>
  </div>
);

const LoggedIn = ({ auth, loading }, context) => (
  <div class={style.loggedInView}>
    <table class={style.detailsTable}>
      <tbody>
        <tr>
          <td class={style.tableColumn}>
            <Text p class={`${style.mutedTitle} hug`}>{I18n.t("Full name")}</Text>
          </td>
          <td class={style.tableColumn}>
            {auth.firstname} {auth.lastname}
          </td>
        </tr>
        <tr>
          <td class={style.tableColumn}>
            <Text p class={`${style.mutedTitle} hug`}>{I18n.t("Phone number")}</Text>
          </td>
          <td class={style.tableColumn}>{auth.mobile_phone}</td>
        </tr>
        <tr>
          <td class={style.tableColumn}>
            <Text p class={`${style.mutedTitle} hug`}>{I18n.t("Email")}</Text>
          </td>
          <td class={style.tableColumn}>{auth.email}</td>
        </tr>
      </tbody>
    </table>
    <div class={style.logoutWrapper}>
      <Button class="defaultButton" onClick={context.auth.logout} loading={loading}>{I18n.t("Logout")}</Button>
    </div>
  </div>
);

export default class AuthModal extends Component {
  state = {
    auth: { country_code: this.context.lang === 'ee' ? 'EE' : 'FI' },
    view: 'email',
    acceptedTerms: false,
  };
  titles = {
    email: I18n.t('Welcome to TableOnline'),
    create: I18n.t('Create an account'),
    password: I18n.t('Enter your password'),
    loggedIn: I18n.t('Welcome back!'),
  };
  next = e => {
    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    this.setState({ error: null, loading: true });

    if (this.state.view === 'email' || !this.state.auth.password) {
      this.setState({ loading: false, view: 'password' });
    } else if (this.state.view === 'create') {
      if (this.state.auth.password !== this.state.auth.repassword) {
        this.setState({
          error: I18n.t('Passwords do not match'),
          loading: false,
        });
        return;
      } else if (
        this.state.auth.password &&
        this.state.auth.password.length < 8
      ) {
        this.setState({
          error: I18n.t('Password should be at least 8 characters long'),
          loading: false,
        });
        return;
      } else if (
        this.state.auth.mobile_phone &&
        this.state.auth.mobile_phone.indexOf('+') !== -1
      ) {
        this.setState({
          error: I18n.t('Phone number should not contain country code'),
          loading: false,
        });
        return;
      }
      this.context.auth
        .createAccount(this.state.auth)
        .then(res => {
          if (res && res.user) {
            this.context.auth
              .login(this.state.auth)
              .catch(error =>
                this.setState({ error: error.toString(), loading: false })
              );
          }
        })
        .catch(error => {
          this.setState({ error: error.toString(), loading: false });
        });
    } else if (this.state.view === 'password') {
      this.context.auth
        .login(this.state.auth)
        .catch(error =>
          this.setState({ error: error.toString(), loading: false })
        );
    }
    //this.setState({ view: 'create' })
  };
  componentDidMount() {
    if (this.props.view) this.state.view = this.props.view;
  }
  render(props, state) {
    return (
      <Stateful events={['auth']}>
        {({ auth }) => (
          <Button
            class={style.authTrigger}
            style={props.style ? props.style : null}
            onClick={e => {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.setState({ showModal: true });
            }}
          >
            <span>
              {props.label ? (
                props.label
              ) : auth ? (
                auth.firstname
              ) : (
                <Text>{I18n.t("Login / Sign up")}</Text>
              )}
            </span>
            <Modal
              title={this.titles[auth ? 'loggedIn' : state.view]}
              show={state.showModal}
              close={() => this.setState({ showModal: false })}
              class={style.authModal}
            >
              {auth ? (
                <LoggedIn
                  auth={auth}
                  onChange={auth => this.setState({ auth })}
                  onSubmit={this.next}
                />
              ) : state.view === 'email' ? (
                <EmailForm
                  error={state.error}
                  loading={state.loading}
                  auth={state.auth}
                  onChange={auth => {
                    this.setState(state => ({
                      auth: { ...state.auth, ...auth },
                    }));
                  }}
                  onSubmit={this.next}
                  onCreate={() =>
                    this.setState({ view: 'create', error: null })
                  }
                  onForgot={() =>
                    this.setState({ error: 'Enter valid email address' })
                  }
                />
              ) : state.view === 'create' ? (
                <PersonalDetails
                  error={state.error}
                  loading={state.loading}
                  auth={state.auth}
                  onChange={auth => this.setState({ auth })}
                  onSubmit={this.next}
                  onEmail={() => this.setState({ view: 'email', error: null })}
                  acceptedTerms={state.acceptedTerms}
                  onAccept={e => {
                    this.setState({ acceptedTerms: e.target.checked });
                  }}
                />
              ) : state.view === 'password' ? (
                <EnterPassword
                  error={state.error}
                  loading={state.loading}
                  auth={state.auth}
                  onChange={auth => this.setState({ auth })}
                  onSubmit={this.next}
                  onEmail={() => this.setState({ view: 'email', error: null })}
                />
              ) : null}
            </Modal>
          </Button>
        )}
      </Stateful>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/index.js